/**** session clear when user enter from menue start  ****/
jQuery(".list-menu").click(function() {
  localStorage.clear();
});
